export default __webpack_public_path__ + "static/media/map_circle.c676634f.svg";